import callbackRegistry from "./callbackRegistry/callbackRegistry";

export const getRandomUUID = () => {
  try {
    return crypto.randomUUID();
  } catch {
    return ("" + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(
      /[01]/g,
      function () {
        return (0 | (Math.random() * 16)).toString(16); //NOSONAR
      }
    );
  }
};

export default class BridgePromise {
  uuid;
  _thenCB = () => {};
  _errCB = () => {};

  constructor(executor, removeAfterExec = true) {
    Promise.resolve().then(() => {
      this.uuid = getRandomUUID();
      callbackRegistry.register(
        this.uuid,
        this._thenCB,
        this._errCB,
        removeAfterExec
      );
      executor(this.uuid);
    });
  }

  getUUID() {
    return this.uuid;
  }

  then(cb) {
    this._thenCB = cb;
    return this;
  }
  catch(cb) {
    this._errCB = cb;
    return this;
  }

  unsubscribe() {
    callbackRegistry.unregister(this.uuid);
  }
}

export const bridgePromiseWrapper = cb =>
  new Promise((res, rej) => {
    new BridgePromise(uuid => {
      cb(uuid);
    })
      .then(data => {
        res(data);
      })
      .catch(err => {
        rej(err);
      });
  });
